import angular from 'angular';

import './login-screen.style.scss';

import LoginScreenController from './login-screen.controller';

export default angular.module('autoboard.loginScreen', [])
  .controller('LoginScreenController', LoginScreenController)
  .name;
